import axios from 'axios';
import { type FilterSelectedValue } from '../hooks/filters/interfaces/filter-selected-value.interface';
import { SortBy } from '../interfaces/sort-by.interface';

const API_URL = process.env.REACT_APP_API_URL;

interface ProviderParams {
  report_name: string;
  report_id?: string;
  pageNumber: number;
  itemsPerPage: number;
  sortBy: SortBy[] | undefined;
}

export const getDataProvider = async <T>(
  report_name: string,
  report_id: string,
  pageNumber: number,
  itemsPerPage: number,
  sortBy: SortBy[] | undefined,
  filterSelection: FilterSelectedValue[],
): Promise<T> => {
  const body = {
    params: {
      report_name,
      pageNumber,
      itemsPerPage,
      sortBy,
    } as ProviderParams,
    data: { filterSelection },
  };

  if (report_id !== '') {
    body.params.report_id = report_id;
  }

  return (await axios.get(`${API_URL}data-provider`, body)).data;
};

export const getSpreadSheetsProvider = async <T>(
  report_name: string,
  report_id: string,
  pageNumber: number,
  itemsPerPage: number,
  sortBy: SortBy[] | undefined,
  filterSelection: FilterSelectedValue[],
): Promise<T> => {
  const params: ProviderParams = {
    report_name: encodeURIComponent(report_name),
    pageNumber,
    itemsPerPage,
    sortBy,
  };

  if (report_id !== '') {
    params.report_id = encodeURIComponent(report_id);
  }

  return await axios.get(`${API_URL}spread-sheets-provider`, {
    responseType: 'blob',
    params: params,
    data: { filterSelection },
  });
};
